<template>
  <div>
    <form @submit.prevent="createPromo">
      <modal v-show="isModalVisible" @close="closeModal" modalIsLarge footer>
        <template v-slot:title>
          <h5>Create Promo</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  type="text"
                  v-model="formObj.name"
                  class="form-control"
                  placeholder="Promo's Name"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="daily_limit">Daily Limit</label>
                <input
                  type="text"
                  v-model="formObj.daily_limit"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Daily Limit"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="daily_limit">User Daily Limit</label>
                <input
                  type="text"
                  v-model="formObj.user_daily_limit"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Daily Limit"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="code">Promo Code</label>
                <input
                  type="text"
                  v-model="formObj.code"
                  class="form-control"
                  placeholder="Promo Code"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="daily_limit">Description</label>
                <textarea
                  type="text"
                  v-model="formObj.description"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="monthly_limit">Monthly Limit</label>
                <input
                  type="text"
                  v-model="formObj.monthly_limit"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Monthly Limit"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="user_limit">User Limit</label>
                <input
                  type="text"
                  v-model="formObj.user_limit"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's User Limit"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="promo_type">Promo Type</label>
                <select
                  name=""
                  v-model="formObj.type"
                  id=""
                  class="form-control"
                >
                  <option value="" disabled selected
                    >Pleease Select Type</option
                  >
                  <option value="percent">Percent</option>
                  <option value="flat">Flat</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="value">Value</label>
                <input
                  type="text"
                  v-model="formObj.value"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Value"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="cap">Cap</label>
                <input
                  type="text"
                  v-model="formObj.cap"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Cap"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="cap">Min Transaction Amount</label>
                <input
                  type="text"
                  v-model="formObj.min_transaction_amount"
                  @keypress="isNumber($event)"
                  class="form-control"
                  placeholder="Promo's Min Amount"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="promo_category">Promo Category</label>
                <select
                  name=""
                  v-model="formObj.category"
                  id=""
                  class="form-control"
                >
                  <option value="" disabled selected
                    >Pleease Select Type</option
                  >
                  <option value="referral">Referral</option>
                  <option value="new-user-bonus">New User Bonus</option>
                  <option value="cashback">Airtime Cashback</option>
                  <option value="kiddies-card-discount">Kiddies Card Discount</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class=" form-group">
                <label for="start_date">Start Date</label>
                <input
                  type="date"
                  v-model="formObj.start_date"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class=" form-group">
                <label for="end_date">End Date</label>
                <input
                  type="date"
                  v-model="formObj.end_date"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Status</label>
                <select
                  name=""
                  id=""
                  class="form-control"
                  v-model="formObj.status"
                >
                  <option value="" disabled selected
                    >Please Select Status</option
                  >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class=" form-group">
                <label for="start_date">Cap Message</label>
                <input
                  type="text"
                  v-model="formObj.cap_message"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class=" form-group">
                <label for="start_date">Service IDs</label>
                <input
                  type="text"
                  v-model="formObj.service_ids"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            class="btn btn-primary"
            @submit.prevent="createUpdatePromo"
            :disabled="loading"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Updating ...
              </span>
            </span>
            <span v-else>
              Create Promo
            </span>
          </button>
          <button @click.prevent="closeModal" class="btn btn-secondary">
            Close
          </button>
        </template>
      </modal>
    </form>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Promos ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h3 class=" mb-2 font-regular">Promos</h3>
        </div>
        <div class="col-auto">
          <button
            class="button button--outline text-uppercase"
            @click="openModal"
          >
            Create Promo
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="arr"
              :fields="fields"
              pagination
              sorter
              tableFilter
            >
              <template #start_date="{item}">
                <td class="table--action-mobile">
                  {{ item.start_date | date }}
                </td>
              </template>
              <template #end_date="{item}">
                <td class="table--action-mobile">
                  {{ item.end_date | date }}
                </td>
              </template>
              <template #actions="{item}">
                <td class="table--action-mobile d-flex border-0">
                  <button
                    class="btn btn-secondary me-2"
                    @click="showUpdatemodal(item)"
                  >
                    Edit
                  </button>
                  <router-link
                    class="button"
                    :to="{ name: 'Promo', params: { slug: item.id } }"
                  >
                    View</router-link
                  >
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";

const fields = [
  "name",
  "daily_limit",
  "monthly_limit",
  "user_limit",
  "code",
  "type",
  "value",
  "cap",
  "category",
  "start_date",
  "end_date",
  "actions"
];

export default {
  name: "PromosPage",
  components: {
    CDataTable
  },
  computed: {
    formIsNotValid() {
      for (let key in this.formObj) {
        if (this.formObj.hasOwnProperty(key) && this.formObj[key] === "") {
          return true;
        }
      }
      return false;
    }
  },
  data() {
    return {
      fields,
      isModalVisible: false,
      pageLoading: true,
      loading: false,
      arr: [],
      formObj: {
        name: "",
        daily_limit: "",
        monthly_limit: "",
        user_daily_limit : "",
        user_limit: "",
        type: "",
        value: "",
        cap: "",
        category: "",
        start_date: "",
        end_date: "",
        status: "",
        cap_message: "",
        description : "",
        sevice_ids: "",
        code: ""
      }
    };
  },
  methods: {
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async createPromo() {
      this.loading = true;
      console.log(this.formObj);
      try {
        const res = await ApiService.post("promo/create-update", this.formObj);

        this.closeModal();
        this.loading = false;
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.getPromos();
      } catch (error) {
        this.closeModal();
        console.log(error);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.loading = false;
      }
    },

    async getPromos() {
      try {
        const res = await ApiService.get("promo/all/admin");

        this.arr = res.data.data;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    async showUpdatemodal(item) {
      this.formObj = item;
      this.openModal();
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
  mounted() {
    this.getPromos();
  }
};
</script>

<style scoped></style>
